import { Component, createRef } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

//  Images
import arrowIcon1 from "include/images/arrow-down-icon-1.svg";
import arrowIcon2 from "include/images/arrow-down-icon-2.svg";
import arrowIcon from "include/images/arrow-down-icon.svg";
import emptyIcon from "include/images/nrf.svg";

//  Components
import Header from "common/header";
import Loader from "common/loader";
import SideBar from "common/sidebar";
import AddCard from "./updateSpinnerRewards";
import { getTelegram, loadTelegramSpinReward, validateTelegramSpinReward } from "store/telegram";
import AlertSuccess from "common/alert/alertSuccess";
import { toast } from "react-toastify";
import AlertError from "common/alert/alertError";

class SpinRewardsListing extends Component {
  ref = createRef(null);
  state = {
    loadingMain: false,
    loadingDelete: false,
    showDeleteModal: false,
    showAddModal: false,
    deleteId: "",
    editData: null,
    sorting: { sort: "value", order: "desc" },
    page: 1,
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (!this.props.getTelegram.loading && this.props.getTelegram.loading !== prevProps.getTelegram.loading)
      this.ref.current.complete();

    if (this.props.getTelegram.loading && this.props.getTelegram.loading !== prevProps.getTelegram.loading)
      this.ref.current.continuousStart();
    if (this.state.showAddModal !== prevState.showAddModal && !this.state.showAddModal) {
      setTimeout(() => {
        this.setState({ editData: null });
      }, 500);
    }
  };
  componentDidMount = () => {
    this.setState({ loadingMain: true });
    this.props.loadTelegramSpinReward({}, (res) => {
      this.setState({
        loadingMain: false,
      });
    });
  };

  toggleAddModal = (e) => {
    if (e) e.preventDefault();
    this.setState({ showAddModal: !this.state.showAddModal });
  };

  alertModalToggle = (e) => {
    if (e) e.preventDefault();
    this.setState({ showDeleteModal: !this.state.showDeleteModal });
  };
  sort = (e, type) => {
    if (e) e.preventDefault();
    const sorting = { ...this.state.sorting };
    if (type === 1) {
      if (sorting?.sort === "value" && sorting?.order === "desc") {
        sorting.order = "asc";
      } else {
        sorting.order = "desc";
      }
      sorting.sort = "value";
    } else if (type === 2) {
      if (sorting?.sort === "rewardType" && sorting?.order === "desc") {
        sorting.order = "asc";
      } else {
        sorting.order = "desc";
      }
      sorting.sort = "rewardType";
    } else if (type === 3) {
      if (sorting?.sort === "stageOnePercentage" && sorting?.order === "desc") {
        sorting.order = "asc";
      } else {
        sorting.order = "desc";
      }
      sorting.sort = "stageOnePercentage";
    } else if (type === 4) {
      if (sorting?.sort === "stageTwoPercentage" && sorting?.order === "desc") {
        sorting.order = "asc";
      } else {
        sorting.order = "desc";
      }
      sorting.sort = "stageTwoPercentage";
    } else if (type === 5) {
      if (sorting?.sort === "stageThreePercentage" && sorting?.order === "desc") {
        sorting.order = "asc";
      } else {
        sorting.order = "desc";
      }
      sorting.sort = "stageThreePercentage";
    } else if (type === 6) {
      if (sorting?.sort === "stageFourPercentage" && sorting?.order === "desc") {
        sorting.order = "asc";
      } else {
        sorting.order = "desc";
      }
      sorting.sort = "stageFourPercentage";
    } else if (type === 7) {
      if (sorting?.sort === "stageFivePercentage" && sorting?.order === "desc") {
        sorting.order = "asc";
      } else {
        sorting.order = "desc";
      }
      sorting.sort = "stageFivePercentage";
    }
    this.setState({ sorting });
  };
  validate = () => {
    this.props.validateTelegramSpinReward((res) => {
      if (res.status === 200) {
        toast(<AlertSuccess message={res?.data?.message} />, {
          containerId: 1,
        });
      } else {
        toast(<AlertError message={res.data && res.data.message} />, { containerId: 1 });
      }
    });
  };
  render() {
    const { telegramSpinReward } = this.props.getTelegram;
    const sortedReward = telegramSpinReward?.toSorted((a, b) => {
      const { sort, order } = this.state.sorting;
      const multiplier = order === "desc" ? -1 : 1;

      if (sort === "rewardType") return multiplier * (a?.[sort] > b?.[sort] ? 1 : -1);

      if (sort.endsWith("Percentage")) {
        // Extract the stage key by removing "Percentage" from the sort field.
        const stageKey = sort.replace("Percentage", "");
        const aVal = a?.percentage?.[stageKey] || 0;
        const bVal = b?.percentage?.[stageKey] || 0;
        return multiplier * (aVal - bVal);
      }

      return multiplier * (a?.[sort] - b?.[sort]);
    });
    return (
      <>
        <Header history={this.props.history} />
        <Loader loaderRef={this.ref} />
        <div className="page-wrapper add-dev-server-wrapper">
          <SideBar page="telegram-mini-app-settings-spinner-rewards" />

          {!this.state.loadingMain && (
            <div className="main-content-wrapper position-relative">
              <div className="mcw-header d-flex align-items-center">
                <h1>Spinner Rewards</h1>
                <div className="filter-menu-box d-flex align-items-center ms-auto">
                  <div className="fmb-box">
                    <button className="btn btn-default btn-sm" onClick={this.validate}>
                      Validate
                    </button>
                  </div>
                </div>
              </div>
              <div className="fwc-wrapper">
                <div className="fwc-body">
                  {sortedReward?.length === 0 ? (
                    <div className="fwc-body">
                      <div className="no-record-found-container">
                        <div className="nfr-box">
                          <img src={emptyIcon} alt="No Record Found" />
                          <div className="nrf-text">
                            <h5>No Records Found!</h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table large-table">
                        <thead>
                          <tr>
                            <th>
                              Value
                              <a href="#!" onClick={(e) => this.sort(e, 1)}>
                                <img
                                  src={
                                    this.state.sorting?.sort === "value"
                                      ? this.state.sorting?.order === "desc"
                                        ? arrowIcon1
                                        : arrowIcon2
                                      : arrowIcon
                                  }
                                  alt=""
                                />
                              </a>
                            </th>
                            <th>
                              Reward Type
                              <a href="#!" onClick={(e) => this.sort(e, 2)}>
                                <img
                                  src={
                                    this.state.sorting?.sort === "rewardType"
                                      ? this.state.sorting?.order === "desc"
                                        ? arrowIcon1
                                        : arrowIcon2
                                      : arrowIcon
                                  }
                                  alt=""
                                />
                              </a>
                            </th>
                            <th>
                              Stage One Percentage
                              <a href="#!" onClick={(e) => this.sort(e, 3)}>
                                <img
                                  src={
                                    this.state.sorting?.sort === "stageOnePercentage"
                                      ? this.state.sorting?.order === "desc"
                                        ? arrowIcon1
                                        : arrowIcon2
                                      : arrowIcon
                                  }
                                  alt=""
                                />
                              </a>
                            </th>
                            <th>
                              Stage Two Percentage
                              <a href="#!" onClick={(e) => this.sort(e, 4)}>
                                <img
                                  src={
                                    this.state.sorting?.sort === "stageTwoPercentage"
                                      ? this.state.sorting?.order === "desc"
                                        ? arrowIcon1
                                        : arrowIcon2
                                      : arrowIcon
                                  }
                                  alt=""
                                />
                              </a>
                            </th>
                            <th>
                              Stage Three Percentage
                              <a href="#!" onClick={(e) => this.sort(e, 5)}>
                                <img
                                  src={
                                    this.state.sorting?.sort === "stageThreePercentage"
                                      ? this.state.sorting?.order === "desc"
                                        ? arrowIcon1
                                        : arrowIcon2
                                      : arrowIcon
                                  }
                                  alt=""
                                />
                              </a>
                            </th>
                            <th>
                              Stage Four Percentage
                              <a href="#!" onClick={(e) => this.sort(e, 6)}>
                                <img
                                  src={
                                    this.state.sorting?.sort === "stageFourPercentage"
                                      ? this.state.sorting?.order === "desc"
                                        ? arrowIcon1
                                        : arrowIcon2
                                      : arrowIcon
                                  }
                                  alt=""
                                />
                              </a>
                            </th>
                            <th>
                              Stage Five Percentage
                              <a href="#!" onClick={(e) => this.sort(e, 7)}>
                                <img
                                  src={
                                    this.state.sorting?.sort === "stageFivePercentage"
                                      ? this.state.sorting?.order === "desc"
                                        ? arrowIcon1
                                        : arrowIcon2
                                      : arrowIcon
                                  }
                                  alt=""
                                />
                              </a>
                            </th>
                            <th>Spinner Location</th>
                            <th>Position</th>
                            <th>Angle</th>
                            <th>Color</th>
                            <th>Image</th>
                          </tr>
                        </thead>
                        <tbody>
                          {sortedReward?.map((reward, index) => (
                            <tr key={index}>
                              <td>
                                <Link
                                  className="two-line-ellipsis"
                                  to={"#"}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    this.setState({ editData: reward }, () => {
                                      this.toggleAddModal();
                                    });
                                  }}
                                >
                                  {reward?.value}
                                </Link>
                              </td>
                              <td className="upperCase">
                                {reward?.rewardType === "point" ? "points" : reward?.rewardType}{" "}
                                {reward?.rewardType === "gear" && reward?.element && `- ${reward?.element}`}
                                {reward?.rewardType === "gear" && `- ${reward?.rarity ?? ""}`}
                              </td>
                              <td>{reward?.percentage?.stageOne ?? 0}%</td>
                              <td>{reward?.percentage?.stageTwo ?? 0}%</td>
                              <td>{reward?.percentage?.stageThree ?? 0}%</td>
                              <td>{reward?.percentage?.stageFour ?? 0}%</td>
                              <td>{reward?.percentage?.stageFive ?? 0}%</td>
                              <td>{reward?.spinnerLocation}</td>
                              <td className="text-capitalize">{reward?.position}</td>
                              <td>{reward?.angle}</td>
                              <td>{reward?.color}</td>{" "}
                              <td>
                                <div style={{ width: 60 }}>
                                  {reward?.image && <img src={process.env.REACT_APP_CDN + reward?.image} alt="" />}
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
        <AddCard
          showModal={this.state.showAddModal}
          toggleModal={this.toggleAddModal}
          loadData={this.props.loadTelegramSpinReward}
          edit={this.state.editData}
        />

        {this.state.showAddModal && <div className="modal-backdrop show fade" onClick={this.toggleAddModal}></div>}
      </>
    );
  }
}
const mapDispatchToProps = (dispatch) => ({
  loadTelegramSpinReward: (params, callback) => dispatch(loadTelegramSpinReward(params, callback)),
  validateTelegramSpinReward: (callback) => dispatch(validateTelegramSpinReward(callback)),
});
const mapStateToProps = (state) => ({
  getTelegram: getTelegram(state),
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SpinRewardsListing));
